import { supabaseFetch } from './core';
import { getLevelFromXp } from '../xpUtils';

export const getAthleteXP = async (userId) => {
  const data = await supabaseFetch(`/athlete_xp?user_id=eq.${userId}&select=*`);
  return Array.isArray(data) ? (data[0] || null) : data;
};

/**
 * Award XP for a completed workout. Idempotent: calling twice for the same
 * workoutLogId returns the existing data without double-counting.
 * @returns {{ totalXp, currentLevel, xpGained, leveledUp, prevLevel }}
 */
export const awardWorkoutXP = async (userId, workoutLogId, xpAmount) => {
  // Step 1: Insert xp_event — unique constraint on (workout_log_id, event_type).
  // Con resolution=ignore-duplicates il duplicato NON genera errore: PostgREST
  // fa ON CONFLICT DO NOTHING e risponde 2xx con representation VUOTA. Il flag
  // va quindi derivato dalla risposta (righe inserite = 0 → già assegnato);
  // il catch su 23505 resta solo come cintura per configurazioni diverse.
  let alreadyAwarded = false;
  try {
    const inserted = await supabaseFetch('/xp_events', {
      method: 'POST',
      headers: { 'Prefer': 'return=representation,resolution=ignore-duplicates' },
      body: JSON.stringify({
        user_id: userId,
        workout_log_id: workoutLogId,
        event_type: 'workout_complete',
        xp_amount: xpAmount,
      }),
    });
    // Nel dubbio (risposta vuota/inattesa) meglio NON riaccreditare
    alreadyAwarded = !(Array.isArray(inserted) && inserted.length > 0);
  } catch (err) {
    const msg = err.message || '';
    if (msg.includes('23505') || msg.includes('duplicate') || msg.includes('unique')) {
      alreadyAwarded = true;
    } else {
      throw err;
    }
  }

  // Step 2: Read current totals
  const current = await getAthleteXP(userId);
  const prevTotal = current?.total_xp || 0;
  const prevLevel = current?.current_level || 1;
  const newTotal = alreadyAwarded ? prevTotal : prevTotal + xpAmount;
  const newLevel = getLevelFromXp(newTotal);

  // Step 3: Upsert athlete_xp
  await supabaseFetch('/athlete_xp', {
    method: 'POST',
    headers: { 'Prefer': 'return=representation,resolution=merge-duplicates' },
    body: JSON.stringify({
      user_id: userId,
      total_xp: newTotal,
      current_level: newLevel,
      updated_at: new Date().toISOString(),
    }),
  });

  return {
    totalXp: newTotal,
    currentLevel: newLevel,
    xpGained: alreadyAwarded ? 0 : xpAmount,
    leveledUp: newLevel > prevLevel,
    prevLevel,
  };
};
